import React, {useEffect, useRef, useState} from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Label from '@mui/material/FormLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ArrowForward from '@mui/icons-material/ArrowForward';

import api from '../../services/api';

import {SectionProps, StateConfig} from '../../types/form';
import StateError from '../errors/StateError';


const Section3 = (props: SectionProps) => {

    const {
        handleNext,
        values,
        setValues,
        enabledStates,
    } = props;

    /**
     * LOAD STATES
     */
    const [states, setStates] = useState([]);
    const [state, setState] = useState('');

    useEffect(() => {
        api.get('locations/states/search/').then(res => setStates(res.data.results));
    }, []);

    /**
     * LOAD CITIES
     */
    const [cities, setCities] = useState([]);

    useEffect(() => {
        if (!!state) {
            setCities([]);
            api.get(`locations/states/search/${state}/cities`).then(res => setCities(res.data.results));
        }
    }, [state]);

    /**
     * FORM SUBMIT TO NEXT SECTION
     */
    const [stateError, setStateError] = useState(false);
    const formRef = useRef<HTMLFormElement>(null);
    const handleNextClick = () => {
        if (!formRef.current) {
            return;
        }

        formRef.current.reportValidity();

        if (formRef.current.checkValidity()) {
            const stateObj = enabledStates.find((s: StateConfig) => s.id === parseInt(state));

            if (!stateObj || (values.driver_type === '1' && !stateObj.trucker_enabled) || (values.driver_type === '2' && !stateObj.learner_enabled)) {
                setStateError(true);
                return;
            }

            handleNext();
        }
    };

    if (stateError) {
        return (<StateError/>);
    }

    return (
        <Box>
            <Typography variant={'h2'}>
                Endereço
            </Typography>
            <Typography variant={'body1'} sx={{mb: '20px'}}>
                Atenção deverá apresentar comprovante de endereço, na entrevista.
            </Typography>

            <Box component={'form'} ref={formRef}>
                <Stack direction={'column'} spacing={3}>
                    <FormControl fullWidth>
                        <Label sx={{mb: 1}}>Estado de residência *</Label>
                        <Select
                            required={true}
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                        >
                            {states.map((uf: any) => (
                                <MenuItem key={uf.id} value={uf.id}>{uf.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth>
                        <Label sx={{mb: 1}}>Cidade de residência *</Label>
                        <Select
                            required={true}
                            value={values['residence_city']}
                            onChange={(e) => {
                                setValues({...values, residence_city: e.target.value});
                            }}
                            disabled={cities.length === 0}
                        >
                            {cities.map((city: any) => (
                                <MenuItem key={city.id} value={city.id}>{city.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Stack>

                <Stack direction={'row'} justifyContent={'end'} sx={{mt: 5}}>
                    <Button variant={'contained'} onClick={handleNextClick}>
                        Próximo
                        <ArrowForward fontSize={'small'} sx={{ml: 2}}/>
                    </Button>
                </Stack>
            </Box>
        </Box>
    );
};

export default Section3;